import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import Stripe from "stripe";

interface StripeAccountDetails {
  email: string | null;
  payouts_enabled: boolean;
  details_submitted: boolean;
  charges_enabled: boolean;
  country: string;
  default_currency: string;
  capabilities: Stripe.Response<Stripe.Capability>;
  requirements: {
    alternatives: any[];
    current_deadline: number | null;
    currently_due: string[];
    disabled_reason: string | null;
    errors: any[];
    eventually_due: string[];
    past_due: string[];
    pending_verification: string[];
  };
  external_accounts: {
    object: string;
    data: any[];
    has_more: boolean;
    url: string;
  } | null;
}

interface CreateAccountLinkRequest {
  current_url: string;
}

interface CreateAccountLinkResponse {
  url: string;
}

export const connectApi = createApi({
  reducerPath: "connectApi",
  baseQuery: fetchBaseQuery({ baseUrl: `/api` }),
  keepUnusedDataFor: 5 * 60,
  tagTypes: ["StripeConnectAccount"],
  endpoints: (build) => ({
    getConnectAccount: build.query<
      {
        account: Stripe.Response<Stripe.Account>;
        capability: Stripe.Response<Stripe.Capability>;
      },
      void
    >({
      query: () => `/stripe/connect/account`,
      providesTags: ["StripeConnectAccount"],
    }),
    getStripeAccountDetails: build.query<StripeAccountDetails, void>({
      query: () => `/stripe/manage-account`,
      providesTags: ["StripeConnectAccount"],
    }),
    createStripeAccountLink: build.mutation<
      CreateAccountLinkResponse,
      CreateAccountLinkRequest
    >({
      query: (body) => ({
        url: `/stripe/manage-account`,
        method: "POST",
        body,
      }),
    }),

    updateStripeAccountCapability: build.mutation<
      void,
      { stripeAccountId: string }
    >({
      query: () => ({
        url: `/stripe/manage-account`,
        method: "PATCH",
      }),
      invalidatesTags: ["StripeConnectAccount"],
    }),
  }),
});

export const {
  useGetConnectAccountQuery,
  useGetStripeAccountDetailsQuery,
  useCreateStripeAccountLinkMutation,
  useUpdateStripeAccountCapabilityMutation,
} = connectApi;
